import React, { useEffect, useState } from "react";
import styles from './LandingPage.module.css';

const Banner = (props) => {

    return (
        <section className={styles.heroBanner}>

            <div className={`${styles.landingContainer} ${styles.heroBannerInner}`}>

                <div className={styles.heroBannerLeft}>

                    <div className={styles.phones}>
                        <img src="https://admin.rebeltv.me/rebel-homepage-assets/phones.png" />
                    </div>

                </div>

                <div className={styles.heroBannerLeft}>

                    <h1>
                        GET PAID, NOT<br />
                        <span>JUST LIKES</span>
                    </h1>

                    <p>
                        Turn your creativity into income.<br />
                        Rebel empowers creators to monetize through subscriptions, tips, paid per view, and exclusive content
                    </p>

                    <a className={styles.cta} href="/signup">Start Creating</a>

                </div>

            </div>

        </section>
    );
};

export default Banner;